import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { FaSpinner } from 'react-icons/fa6';

/**
 * LoadingState sub-component
 * Shows loading spinner while fetching violin plots
 */
export const LoadingState: React.FC = memo(() => {
  const { t } = useTranslation('training');

  return (
    <div className="mt-6 sm:mt-8 rounded-xl border border-border bg-card overflow-hidden shadow-sm">
      <div className="flex flex-col items-center justify-center py-16 sm:py-20">
        <div className="inline-flex items-center justify-center w-10 h-10 rounded-full bg-accent mb-3">
          <FaSpinner className="animate-spin text-primary text-sm" />
        </div>
        <span className="text-sm text-muted-foreground">
          {t('training.visualization.loading')}
        </span>
      </div>
    </div>
  );
});

LoadingState.displayName = 'LoadingState';

export default LoadingState;
